import clsx from 'clsx';

import { useVoiceDemo } from '../../providers/VoiceDemoContext';

import { EditorComponent } from './EditorNew';

export const MAX_EDITOR_CONTENT_LENGTH = 500;

export function Editor() {
  const { currentContent } = useVoiceDemo();

  return (
    <div className="relative">
      <EditorComponent />

      <div
        className={clsx(
          'absolute bottom-[-22px] right-0 flex text-[#747580] @sm:bottom-[-62px]',
          {
            'text-[red]':
              currentContent.trim().length > MAX_EDITOR_CONTENT_LENGTH,
          },
        )}>
        {currentContent.trim().length}/{MAX_EDITOR_CONTENT_LENGTH}
      </div>
    </div>
  );
}
